import { Component } from "@angular/core";
import { AppService } from "src/app/_services/app.service";
import { BackgroundLocationService } from "src/app/_services/background-location.service";

@Component({
  selector: "app-background-location-always",
  templateUrl: "./background-location-always.component.html",
  styleUrls: ["./background-location-always.component.scss"],
  standalone: false,
})
export class BackgroundLocationAlwaysComponent {
  constructor(
    private appService: AppService,
    private backgroundLocationService: BackgroundLocationService
  ) {}

  closeModal() {
    this.appService.markBackgroundLocationAlwaysDismissed();
  }

  async openSettings() {
    await this.backgroundLocationService.openAppLocationSettings();
    this.appService.dispatchModal("BACKGROUND_LOCATION_ALWAYS_MODAL", false);
  }
}
